import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrivyProvider } from '@privy-io/react-auth';
import './i18n';
import App from './App';
import 'antd/dist/reset.css';
import './styles/variables.css';
import './styles/global.css';
import './styles/antd.css';

const rootElement = document.getElementById('root');
const privyAppId = process.env.REACT_APP_PRIVY_APP_ID;

if (!rootElement) {
    throw new Error('Root element not found');
}

if (!privyAppId) {
    throw new Error('REACT_APP_PRIVY_APP_ID is not configured');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
    <PrivyProvider
        appId={privyAppId}
        config={{
            loginMethods: ['passkey' , 'google'],
        }}
    >
        <App />
    </PrivyProvider>
);
